import React, { ReactNode } from 'react';
import './index.less';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

interface StepsMap {
  title: string,
  content?: ReactNode
  href?: string
}

interface Props {
  current: number,
  stepsMap: StepsMap[]
}

const Index = (props: Props) => {
  const {current, stepsMap} = props;
  const navigate = useNavigate();
  const handleClick = (item: StepsMap) => {
    if (!item.href) {
      return;
    }

    navigate(item.href);
  };
  return (
    <div className="custom_steps_wrap">
      <ul className={classNames('custom_steps_ul', `cur_steps_${current}`)}>
        {stepsMap.map((item, index) => (
          <li className={classNames('custom_steps_li', `custom_steps_li_${index}`)}
              key={item.title}>
            <span className="title">{item.title}</span>
            <span className={classNames('num', {num_link: item.href})}
                  onClick={() => handleClick(item)}>{index + 1}</span>
            <i className="line"></i>
          </li>
        ))}
      </ul>
    </div>

  );
};

export default Index;
